import script from "./SexView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SexView.vue?vue&type=script&lang=ts&setup=true"

import "./SexView.vue?vue&type=style&index=0&id=9c2a9606&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c2a9606"]])

export default __exports__